import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useGeneralContext } from '../context';

const PremiumUpsellModal = (props: {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  onUpgradeClick?: () => void;
  message?: string;
}) => {
  const context = useGeneralContext();
  const { setPlansModalOpen } = context;
  const { showModal, setShowModal, message, onUpgradeClick } = props;

  const handleCancel = () => {
    setShowModal(false);
  };
  
  return (
    <Modal show={showModal} onHide={handleCancel}>
      <Modal.Header closeButton className="tw-border-b tw-border-neutral-200">
        <Modal.Title className="tw-text-lg tw-font-semibold tw-uppercase tw-text-primary-800">THIS IS A PREMIUM FEATURE</Modal.Title>
      </Modal.Header>
      <Modal.Body className="tw-py-4 tw-px-4 tw-text-neutral-800">
        {message ||
          'Get access to journaling assistance and AI assisted journal exploration by upgrading to Jumble Premium!'}
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-end tw-gap-3 tw-border-t tw-border-neutral-200 tw-py-3 tw-px-4">
        <Button
          onClick={() => {
            setShowModal(false);
          }}
          variant="secondary"
          className="tw-bg-neutral-100 tw-text-neutral-800 tw-border tw-border-neutral-300 tw-rounded tw-py-2 tw-px-4 hover:tw-bg-neutral-200"
        >
          Close
        </Button>
        <Button
          onClick={() => {
            setShowModal(false);
            if (onUpgradeClick !== undefined) {
              return onUpgradeClick();
            } else {
              setPlansModalOpen(true);
            }
          }}
          variant="primary"
          className="tw-bg-primary-600 tw-text-white tw-border tw-border-primary-600 tw-rounded tw-py-2 tw-px-4 hover:tw-bg-primary-700"
        >
          Unlock
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PremiumUpsellModal;
